import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
} from '@components/table/widgets/shared-with-old';

export const vignetteRangeHeaders: Record<string, EnhancedTableHeader> = {
  SalesforceManagement_BusinessPartnerVignetteRange_RangeYear: {
    name: 'salesforceManagement_BusinessPartnerVignetteRange_RangeYear',
    title: 'Vignette Range Year',
    type: EnhancedTableHeaderType.Text,
  },
  SalesforceManagement_BusinessPartnerVignetteRange_RangeCode: {
    name: 'salesforceManagement_BusinessPartnerVignetteRange_RangeCode',
    title: 'Vignette Range Code',
    type: EnhancedTableHeaderType.Text,
  },
  SalesforceManagement_BusinessPartnerVignetteRange_RangeFrom: {
    name: 'salesforceManagement_BusinessPartnerVignetteRange_RangeFrom',
    title: 'Vignette Range Fom',
    type: EnhancedTableHeaderType.Text,
  },
  SalesforceManagement_BusinessPartnerVignetteRange_RangeTo: {
    name: 'salesforceManagement_BusinessPartnerVignetteRange_RangeTo',
    title: 'Vignette Range To',
    type: EnhancedTableHeaderType.Text,
  },
  SalesforceManagement_BusinessPartnerVignetteRange_RangeStatus: {
    name: 'salesforceManagement_BusinessPartnerVignetteRange_RangeStatus',
    title: 'Vignette Range Status',
    type: EnhancedTableHeaderType.Text,
  },
};
